module.exports = __webpack_public_path__ + "4626c730027e5ff70254d23451537f9a.svg";